<template>
    <div>
        <h4>Bienvenue !</h4>
        <p>Ce service en ligne vous permet d'effectuer votre demande d'affiliation au CNAREFE : le centre national des retraités de France à l'étranger. Le CNAREFE permet la prise en charge des soins lors de vos séjours provisoires en France.</p>
        <p>Avant de commencer, nous avons quelques questions à vous poser pour vérifier votre éligibilité.</p>

        <b-alert show variant="info" class="mb-5">
            <b-icon icon="hand-thumbs-up"></b-icon> Notre <b-link href="#" @click="$actions.showFaq($bvModal)">foire aux questions</b-link> est disponible à tout moment pour vous accompagner.
        </b-alert>

        <b-row class="ml-3 mb-3">
            <b-col cols="8">
                <div class="font-weight-bold">1. Êtes-vous retraité(e) et recevez-vous une pension ?    
                </div>(pension à titre personnel ou de réversion)
            </b-col>
            <b-col cols="4" class="text-right" align-self="center">
                <b-form-radio-group
                id="btn-pension"
                v-model="pension"
                :options="options"
                button-variant="outline-primary"
                name="pension"
                @change="horsUe = adherentCfe = assureCnarefe = activiteProfessionnelle = null"
                buttons
                ></b-form-radio-group>
            </b-col>
        </b-row>

        <b-row class="ml-3 mb-3" v-if="pension">
            <b-col cols="8">
                <strong>2. Résidez-vous hors UE/EEE, Suisse, Royaume-Uni ou Monaco ?</strong> <b-link href="#" v-b-modal.modal-pays-cnarefe-eligible>Voir les pays éligibles...</b-link>
                <b-modal id="modal-pays-cnarefe-eligible" scrollable ok-only title="Pays éligibles au CNAREFE">
                    <ul>
                        <li v-for="item in listePays" :key="item.id">
                            {{ item.nompays }}
                        </li>
                    </ul>
                </b-modal>
            </b-col>
            <b-col cols="4" class="text-right" align-self="center">
                <b-form-radio-group
                id="btn-hors-ue"
                v-model="horsUe"
                :options="options"
                button-variant="outline-primary"
                name="hors-ue"
                @change="adherentCfe = assureCnarefe = activiteProfessionnelle = null"
                buttons
                ></b-form-radio-group>
            </b-col>
        </b-row>

        <b-row class="ml-3 mb-3" v-if="horsUe">
            <b-col cols="8" class="font-weight-bold">
                3. Êtes-vous actuellement adhérent(e) à la CFE (Caisse des Français de l'Etranger) ?
            </b-col>
            <b-col cols="4" class="text-right" align-self="center">
                <b-form-radio-group
                id="btn-adherent-cfe"
                v-model="adherentCfe"
                :options="options"
                button-variant="outline-primary"
                name="adherent-cfe"
                @change="assureCnarefe = activiteProfessionnelle = null"
                buttons
                ></b-form-radio-group>
            </b-col>
        </b-row>

        <b-row class="ml-3 mb-3" v-if="adherentCfe == 0">
            <b-col cols="8" class="font-weight-bold">
                4. Êtes-vous déjà assuré(e) au CNAREFE ?
            </b-col>
            <b-col cols="4" class="text-right" align-self="center">
                <b-form-radio-group
                id="btn-assure-cnarefe"
                v-model="assureCnarefe"
                :options="options"
                button-variant="outline-primary"
                name="assure-cnarefe"
                @change="activiteProfessionnelle = null"
                buttons
                ></b-form-radio-group>
            </b-col>
        </b-row>

        <b-row class="ml-3 mb-3" v-if="assureCnarefe == 0">
            <b-col cols="8" class="font-weight-bold">
                5. Attestez-vous sur l'honneur ne pas exercer d'activité professionnelle ?
            </b-col>
            <b-col cols="4" class="text-right" align-self="center">
                <b-form-radio-group
                id="btn-activite-professionnelle"
                v-model="activiteProfessionnelle"
                :options="options"
                button-variant="outline-primary"
                name="activite-professionnelle"
                buttons
                ></b-form-radio-group>
            </b-col>
        </b-row>        

        <b-alert show v-if="pension == 0" variant="danger">
            <b-row align-v="center">
                <b-col cols="auto">
                    <b-icon icon="x-circle" scale="1.5"></b-icon>
                </b-col>
                <b-col>
                    <h5>Vous ne percevez pas de pension retraite</h5>
                    Nous vous invitons à contacter votre Caisse de retraite pour connaître vos droits et démarches à accomplir.
                </b-col>
            </b-row>
        </b-alert>

        <b-alert show v-if="horsUe == 0" variant="danger">
            <b-row align-v="center">
                <b-col cols="auto">
                    <b-icon icon="x-circle" scale="1.5"></b-icon>
                </b-col>
                <b-col>
                    <h5>Vous résidez dans un pays de l'UE/EEE, en Suisse, au Royaume-Uni ou à Monaco</h5>
                    Nous vous invitons à contacter votre dernière CPAM d'affiliation pour connaître vos droits et démarches à accomplir.
                </b-col>
            </b-row>
        </b-alert>

        <b-alert show v-if="adherentCfe" variant="danger">
            <b-row align-v="center">
                <b-col cols="auto">
                    <b-icon icon="x-circle" scale="1.5"></b-icon>
                </b-col>
                <b-col>
                    <h5>Vous êtes adhérent(e) à la CFE</h5>
                    Nous vous invitons à vous rapprocher de cet organisme pour la prise en charge de vos soins.
                </b-col>
            </b-row>
        </b-alert>

        <b-alert show v-if="assureCnarefe" variant="danger">
            <b-row align-v="center">
                <b-col cols="auto">
                    <b-icon icon="x-circle" scale="1.5"></b-icon>
                </b-col>
                <b-col>
                    <h5>Vous êtes déjà assuré(e) au CNAREFE</h5>
                    Pour poser une question ou nous adresser une pièce nous vous invitons à nous contacter par votre compte AMELI ou par téléphone au <strong>(+33)1.84.90.10.05</strong>
                </b-col>
            </b-row>
        </b-alert>

        <b-alert show v-if="activiteProfessionnelle == 0" variant="danger">
            <b-row align-v="center">
                <b-col cols="auto">
                    <b-icon icon="x-circle" scale="1.5"></b-icon>
                </b-col>
                <b-col>
                    <h5>Vous exercez une activité professionnelle</h5>
                    L'exercice d'une activité professionnelle ne permet pas de s'affilier au CNAREFE pour la prise en charge des frais de santé en cas de séjour temporaire en France.
                </b-col>
            </b-row>
        </b-alert>        

        <b-alert show v-if="stepChecked" variant="info" class="mt-5">
            Afin de poursuivre votre inscription au CNAREFE, nous vous informons qu'une pièce d'identité  dématérialisée vous sera demandée ainsi que le cas échéant, votre domiciliation bancaire et notification de retraite.<br/>
            <br/>
            <b-icon icon="clock"></b-icon> Cette inscription vous prendra environ 10 minutes.
        </b-alert>

        <div v-if="stepChecked" class="text-center mt-5">
            <b-button
                @click="start"
                size="lg"
                variant="primary">
                Commencer mon inscription <b-icon icon="chevron-double-right" animation="cylon" aria-hidden="true"></b-icon>
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Accueil',
  data () {
    return {
      options: [
        { text: 'Oui', value: 1 },
        { text: 'Non', value: 0 }
      ],
      listePays: null
    }
  },
  mounted () {

    // Renvoi vers l'URL du site
    if (this.$store.endOfInscription || this.$store.token === null) {
        this.$actions.router('Init');
    }

    // Envoi un évenement onSetStepper pour mettre a jour l'étape
    this.$emit('onSetStepper', null);

    // Liste des pays hors UE/EEE/Suisse/Royaume-Uni/Monaco etc...
    this.$axios
        .get(this.$config.API + '/pays/cnarefe-eligible', {
            headers: {
                'Authorization': this.$store.token
            }
        })
        .then(response => this.listePays = response.data)
  },
  computed: {
    pension: {
      get() {
        return this.$store.pension
      },
      set(val) {
        this.$store.pension = val;
      }
    },
    horsUe: {
      get() {
        return this.$store.horsUe
      },
      set(val) {
        this.$store.horsUe = val;
      }
    },
    adherentCfe: {
      get() {
        return this.$store.adherentCfe
      },
      set(val) {
        this.$store.adherentCfe = val;
      }
    },
    assureCnarefe: {
      get() {
        return this.$store.assureCnarefe
      },
      set(val) {
        this.$store.assureCnarefe = val;
      }
    },
    activiteProfessionnelle: {
      get() {
        return this.$store.activiteProfessionnelle
      },
      set(val) {
        this.$store.activiteProfessionnelle = val;
      }
    },
    // Variable de verrification globale des données de la page
    stepChecked: function() {
        return this.$actions.getStepChecked('accueil');
    }
  },
  methods: {
    start() {
        this.$actions.router('Identite');
    },
    // Lance la verrification totale des champs sasis afin de savoir si la page est correctement remplie pour passer a l'étape suivante
    checkAll() {
        return (this.pension && this.horsUe && this.adherentCfe == 0 && this.assureCnarefe == 0 && this.activiteProfessionnelle) ? true : false;
    }
  },
  watch: {
    pension: function() {
        this.$actions.setStepChecked('accueil', this.checkAll());
    },
    horsUe: function() {
        this.$actions.setStepChecked('accueil', this.checkAll());
    },
    assureCfe: function() {
        this.$actions.setStepChecked('accueil', this.checkAll());
    },
    assureCnarefe: function() {
        this.$actions.setStepChecked('accueil', this.checkAll());
    },
    activiteProfessionnelle: function() {
        this.$actions.setStepChecked('accueil', this.checkAll());
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Accueil.vue